import React, { FC } from 'react';

import { ClinicsTable, Header } from './components';
import { Wrapper } from './styles';

const Clinics: FC = () => {
  return (
    <Wrapper>
      <Header />
      <ClinicsTable />
    </Wrapper>
  );
};

export default Clinics;
